import {TableCell, TableSortLabel} from '@material-ui/core'
import {ReportsTableContextProps} from 'modules/reports/components/Table/ReportsTable.context'
import React from 'react'
import {TableHeaderProps} from 'react-virtualized'
import usePrefix from 'modules/reports/hooks/prefix'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

type Props = TableHeaderProps & ReportsTableContextProps & {className?: string}

function ReportsTableHeader(props: Props) {
  const {dataKey, label, className, tablePrefix, sortBy, sortDirection} = props

  const p = usePrefix(`${tablePrefix}-header-${dataKey}`)
  const active = sortBy === dataKey

  function renderSortableHeader() {
    return (
      <TableSortLabel
        active={active}
        direction={(sortDirection && sortDirection.toLowerCase()) as any}
        IconComponent={ArrowDropDownIcon}
      >
        {label}
      </TableSortLabel>
    )
  }

  return (
    <TableCell component="div" className={className} variant="head" data-testid={p()}>
      {label && renderSortableHeader()}
    </TableCell>
  )
}

export default ReportsTableHeader
